<div class="loaderwrapper" *ngIf="loader">
    <span class="loader"></span>
</div>

<section class="dashboard-main container-fluid" *ngIf="permissionsReady && !permissions.canView">
    <div class="no-access-wrapper">
        <div class="no-access-card">
            <h4>No Access</h4>
            <p class="mb-0">You don't have permission to view FSR configuration.</p>
        </div>
    </div>
</section>

<section class="dashboard-main container-fluid" *ngIf="permissionsReady && permissions.canView">
    <!-- <div class="contents-main">
        <div class="col-12"> -->
            <div class="card table-card">
                <div class="table-toolbar">
                    <h1 class="table-toolbar__title">FSR Configuration</h1>
                    <div class="sb-filter-holder sb-filter-holder--inline">
                        <div class="btn-group input-wrapper sb-filter-search-group" role="group">
                            <input type="text" class="sb-filter-field sb-filter-search-input"
                                placeholder="Search user type" (input)="searchData($event)">
                            <button type="button" class="btn sb-filter-search-btn">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                    fill="none">
                                    <path
                                        d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M17.5 17.5L13.875 13.875" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="table-wrap" [class.is-loading]="tableLoader">
                    <div class="loaderwrapper" *ngIf="tableLoader">
                        <span class="loader"></span>
                    </div>
                    <div class="table-main">
                        <div>
                            <table class="table-data text-center">
                                <thead>
                                    <tr>
                                        <th scope="col" class="text-start">Sr. No</th>
                                        <th scope="col">USER TYPE</th>
                                        <th scope="col" *ngFor="let column of permissionColumns">
                                            {{ column.label }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngIf="!tableLoader; else LoadingRow">
                                        <tr *ngFor="let item of userTypePermission">
                                            <td class="text-start">{{ item.srNo }}</td>
                                            <td>{{ item.user_type_name }}</td>
                                            <td *ngFor="let column of permissionColumns">
                                                <input class="form-check-input static med" type="checkbox"
                                                    [(ngModel)]="item[column.key]"
                                                    [disabled]="!permissions.canEdit"
                                                    (change)="onPermissionChange(item, column.key)" />
                                            </td>
                                        </tr>
                                        <tr *ngIf="userTypePermission.length === 0">
                                            <td colspan="100%">
                                                <p class="not-found-message p-4 text-center">No records found.</p>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="px-4 pb-4">
                    <small class="text-muted">
                        <b>Approve</b> is the sign-off right on a resolved FSR. The Approve button is additionally
                        limited to the Engineer user type.
                    </small>
                </div>
            </div>
        <!-- </div>
    </div> -->
</section>

<ng-template #LoadingRow>
    <tr>
        <td colspan="100%">
            <div class="d-flex justify-content-center">
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </td>
    </tr>
</ng-template>
